// extracted by mini-css-extract-plugin
export var loadingShimmer = "_r0-2";
export var messageContent = "_r0-0";
export var messagesScroll = "_r0-1";
export var shimmer = "_r0-3";
export var shimmerW100 = "_r0-4";
export var shimmerW70 = "_r0-8";
export var shimmerW80 = "_r0-7";
export var shimmerW85 = "_r0-6";
export var shimmerW90 = "_r0-5";